import React, { Dispatch, forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  LiveRegionProps,
  LiveRegionState,
  LiveRegionRefType,
} from './LiveRegion.types';
import { classes } from './LiveRegion.st.css';

/** LiveRegion */
const LiveRegion = forwardRef<LiveRegionRefType, LiveRegionProps>(
  ({ dataHook }, ref) => {
    const initialState = {
      message: '',
      role: 'status',
    };

    const [state, setState]: [
      LiveRegionState,
      Dispatch<Partial<LiveRegionState>>,
    ] = React.useReducer(
      (currentState: LiveRegionState, newState: Partial<LiveRegionState>) => ({
        ...currentState,
        ...newState,
      }),
      initialState,
    );

    const broadcast = ({
      message: newMessage,
      role = 'status',
    }: LiveRegionState) => {
      if (state.message === newMessage) {
        setState({ message: newMessage + ' ', role });
      } else {
        setState({ message: newMessage, role });
      }
    };

    React.useImperativeHandle(ref, () => ({
      broadcast,
    }));

    return (
      <div
        data-hook={dataHook}
        className={classes.root}
        role={state.role}
        aria-relevant="all"
      >
        {state.message}
      </div>
    );
  },
);

LiveRegion.displayName = 'LiveRegion';

LiveRegion.propTypes = {
  dataHook: PropTypes.string,
  className: PropTypes.string,
};

export default LiveRegion;
